<script>
import { BaseStoryCardElementMixin } from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import { DateElementMixin } from "%/dynamic-component-editor/standard-elements/text-element/date-element-mixin";
import StoryCardClickBehavior from "%/dynamic-component-editor/options/story-card-click-behavior";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";
export default {
  name: "StoryCreated",
  elementPanelSettings: {
    displayName: "Story Created",
    displayIcon: "text-alt",
    elementType: "element",
    elementGroup: "storyElements",
  },
  options: [
    StoryCardClickBehavior,
  ],
  extends: UrlElement,
  mixins: [BaseStoryCardElementMixin, DateElementMixin],
  computed: {
    label() {
      return this.formattedDate(this.entity.publishedAt);
    },
    computedHref() {
      return this.storyHref;
    },
  },
};
</script>
